import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ClipboardStackIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="clipboardStack" ref={ref} {...props}>
    <path d="M17.27,11h-7V9.5h7Zm-1.75,1.71H10.27v1.5h5.25Zm5.84-6.34v9.55A3.39,3.39,0,0,1,18,19.3a3.1,3.1,0,0,1-3,2.6H6.24a3.1,3.1,0,0,1-3.09-3.09V7.86A3.1,3.1,0,0,1,6.24,4.77h0A3.35,3.35,0,0,1,9.24,3h1.95A2.53,2.53,0,0,1,16,3H18A3.38,3.38,0,0,1,21.36,6.37ZM10.86,4.5V5.66h5.5V4.5h-1a.76.76,0,0,1-.75-.75,1,1,0,1,0-2.07,0,.75.75,0,0,1-.75.75Zm5.62,14.8H9.24a3.38,3.38,0,0,1-3.37-3.38V6.32A1.59,1.59,0,0,0,4.65,7.86v11A1.59,1.59,0,0,0,6.24,20.4H15A1.58,1.58,0,0,0,16.48,19.3ZM19.86,6.37A1.88,1.88,0,0,0,18,4.5h-.12V6.41a.76.76,0,0,1-.75.75h-7a.75.75,0,0,1-.75-.75V4.5H9.24A1.87,1.87,0,0,0,7.37,6.37v9.55A1.88,1.88,0,0,0,9.24,17.8H18a1.88,1.88,0,0,0,1.88-1.88Z" />
  </Icon>
)) as IconWithRender;

ClipboardStackIcon.displayName = 'ClipboardStackIcon';
ClipboardStackIcon.renderIcon = (props) => <ClipboardStackIcon {...props} />;
export default ClipboardStackIcon;
